import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import LanguageToggle from "./LanguageToggle";

const HOVER_BLUE = "#0057FF";

export default function PublicNav() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { t, lp } = useLang();
  const isLanding = location.pathname === "/" || location.pathname === "/en" || location.pathname === "/en/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleScrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { id: "como", label: t("nav.como") },
    { id: "planos", label: t("nav.planos") },
    { id: "faq", label: t("nav.faq") },
  ];

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 2.5rem",
        height: 56,
        fontFamily: "'IBM Plex Mono', monospace",
        transition: "background 0.3s, border-color 0.3s, backdrop-filter 0.3s",
        background: scrolled ? "var(--lp-glass-bg)" : "transparent",
        backdropFilter: scrolled ? "blur(20px) saturate(160%)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(20px) saturate(160%)" : "none",
        borderBottom: scrolled ? "0.5px solid var(--lp-border)" : "0.5px solid transparent",
      }}
    >
      <Link
        to={lp("/")}
        style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: "0.95rem",
          fontWeight: 400,
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: "var(--lp-ink)",
          textDecoration: "none",
          transition: "color 0.2s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = HOVER_BLUE)}
        onMouseLeave={(e) => (e.currentTarget.style.color = "var(--lp-ink)")}
      >
        criaaa
      </Link>
      <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
        {isLanding &&
          navLinks.map((l) => (
            <button
              key={l.id}
              onClick={() => handleScrollTo(l.id)}
              className="nav-section-link"
              style={{
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: "0.72rem",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                color: "var(--lp-ink)",
                textDecoration: "none",
                transition: "color 0.2s ease",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = HOVER_BLUE)}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--lp-ink)")}
            >
              {l.label}
            </button>
          ))}
        <Link
          to={lp("/entrar")}
          style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "0.72rem",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "var(--lp-ink)",
            textDecoration: "none",
            transition: "color 0.2s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = HOVER_BLUE)}
          onMouseLeave={(e) => (e.currentTarget.style.color = "var(--lp-ink)")}
        >
          {t("nav.entrar")}
        </Link>
        <LanguageToggle variant="nav" />
      </div>
    </nav>
  );
}
